import { BsCheckLg } from "react-icons/bs";

export default function PreviousTask({content}){
    return (
        <div className="PreviousTask">
            <BsCheckLg className="text-success" /><span className="content">{content}</span>
        </div>
    );
}